import { Box, VStack } from 'native-base';
import React from 'react';
import { useGeneralStyles, useGiftCardStyles } from '~/shared/styles';
import { observer, GIFTCARD_FLOWS } from '@springbig/shared';
import { Caption } from '~/shared/Typography';
import Pressable from '~/shared/Pressable';

const NoCards = () => {

    const {
        empty_card_color,
        empty_card_text_color
    } = useGiftCardStyles();
    
    const onAddCashFunds = () => {

        observer.emit('open-actionsheet', GIFTCARD_FLOWS.addGiftCard);
    };

    return (
        <VStack justifyContent='space-between' flexGrow={1}>
            <Box
                borderStyle='dashed'
                borderWidth={2}
                borderColor={empty_card_color}
                display='flex'
                justifyContent='center'
                alignSelf={'center'}
                width='90%'
                height={170}
                borderRadius={8}
                m={5}
            >
                <Caption
                    alignSelf={'center'}
                    fontSize={20}
                    text='giftCard.addCash'
                    color={empty_card_text_color}
                />
            </Box>
            <Pressable onPress={onAddCashFunds}>
                <Caption
                    fontSize={22}
                    alignSelf='center'
                    p={4}
                    text='giftCard.addCash'
                    color={empty_card_text_color}
                />
            </Pressable>
        </VStack>
    );
};

export default NoCards;
